import gql from "graphql-tag";
import Constants from "../../Constants/Constants";

export function generate_FETCH_DEALS(name, type = 'query') {
    return gql`
  ${type} ${name}_${type}($startDate:timestamptz!, $endDate:timestamptz!, $statusId:[uuid!], $noteExp:String_comparison_exp, $search:String, $offset: Int!, $limit: Int!, $orderBy: [Deals_order_by!]){
   ${name}: Deals(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { statusId: {_in: $statusId}}, {note: $noteExp}, 
        {_or: [{Customer: {name: {_ilike: $search}}}, {Customer: {mobile: {_ilike: $search}}}, {dealNumber: {_ilike: $search}}, {DealItems: {Product: {name: {_ilike: $search}}}} ]} 
        ]}, offset: $offset, limit: $limit, order_by: $orderBy ){
    id
    Customer {id name mobile profileImage city}
    statusId
    DealItems_aggregate{ aggregate {count}}
    totalAmount
    roundOfValue
    dealNumber
    created_at
    approved_at
    rejected_at
    note   
 }
}`
}

export function generate_SUBSCRIBE_DEALS_COUNT(name) {
    return gql`
  subscription ${name}($startDate:timestamptz!, $endDate:timestamptz!, $statusId:[uuid!], $noteExp:String_comparison_exp, $search:String){
   ${name}: Deals_aggregate(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { statusId: {_in: $statusId}}, {note: $noteExp}, 
        {_or: [{Customer: {name: {_ilike: $search}}}, {Customer: {mobile: {_ilike: $search}}}, {dealNumber: {_ilike: $search}}, {DealItems: {Product: {name: {_ilike: $search}}}} ]} ]}){
    aggregate { count }                
   }
}`
}

export const SUBSCRIBE_DEAL_BY_ID = gql`
  subscription dealById($id: uuid!){
    Deals(where:{id: {_eq: $id}}){
      id      
      statusId      
      totalAmount
      roundOfValue
      dealNumber      
      note       
      created_at
      updated_at
      approved_at
      rejected_at
      Status { id status }            
      Customer { id name mobile email profileImage city }  
      DealItems{ id totalPieces pricePerPiece totalPrice cartoons
        Product{
          id
          name
          sku
          Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
          cartonQty 
          purchasePrice
          displayPrice
          WarehouseStock(where: {Warehouse: {isActive: {_eq: true}}}, order_by: {Warehouse: {name: asc}}) {id totalQty Warehouse{id name}}
          KatargamStock: WarehouseStock(where: {warehouseId: {_eq: "${Constants.Warehouses.Katargam}"}}) {id totalQty}
          }
        }                   
    }
  }
`